import { CSSProperties } from "react"

interface SharedProperties {
  "aria-hidden": boolean;
  className: string;
  "data-testid": string;
  id: string;
  role: string;
  style: CSSProperties,
  xmlns: string;
}

export const iconSvgAttributes = (testId: string, classNames: string, style: CSSProperties, isDecorative: boolean): SharedProperties => {
  return {
    "aria-hidden": isDecorative,
    className: classNames,
    "data-testid": testId,
    id: testId,
    role: "img",
    style: style,
    xmlns: "http://www.w3.org/2000/svg",
  };
}